import { useQuery } from "@tanstack/react-query";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";

export default function useWaybill() {
  const { visible, waybillTypes } = useAppSelector((state) => state.waybill);
  const { date } = useAppSelector((state) => state.filters);

  const statusQuery = () => {
    return "status=enable";
  };
  const nameQuery = () => {
    return "type=car";
  };

  const dataForPost = {
    ScenarioUniqueId: "8219b30d-fbad-4e73-b9c1-36b01326461b",
    ServiceUniqueId: "4691b4f0-548c-4af9-a6e4-3a303c012266",
    IncludeNonServiceBranches: false,
    Parameters: {
      "311cc8eb-ab36-40f1-8356-aa0bbb7b57fb": waybillTypes,
      "098fd795-52f0-4494-8205-75d4975055c9": date.created_after || "2020-06-03",
      "916b3adb-28e6-4e8c-9dce-ee5c71f387b7": date.created_before || "2025-06-03",
    },
    InputTables: [],
    OutputColumns: [],
  };

  const { data, refetch, isLoading, isFetching } = useQuery({
    queryKey: [visible, waybillTypes],
    queryFn: () => {
      return Api.sPost(
        "https://report2.ardban.ir:7072/https://report2.ardban.ir:8080/gateway/MSSE.DIA/api/ScenarioServiceCallApi/ShortTimeServiceExecute",
        dataForPost
      ).then((res) => {
        console.log(res.data.Rows, "btrgbtgb");
        return res.data.Rows;
      });
    },
    enabled: visible,
  });

  return { data, isLoading, refetch, isFetching };
}
